// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentsListColumns-EmptyIconLabel_cls1__EbGLb","cls2":"PaymentsListColumns-EmptyIconLabel_cls2__2FauV PaymentsListColumns-EmptyIconLabel_cls1__EbGLb"};